import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { UserRole } from "./UserContext";
export var verifyRole = {
  isStudent: function isStudent(user) {
    return (user === null || user === void 0 ? void 0 : user.role) === UserRole.STUDENT;
  },
  isVisitor: function isVisitor(user) {
    return !(user !== null && user !== void 0 && user.role);
  },
  isRpManager: function isRpManager(user) {
    return [UserRole.AGENT_MANAGER, UserRole.AGENT_REGIONAL_MANAGER, UserRole.AGENT_REGIONAL_MANAGER_SUPERVISOR, UserRole.ADMIN, UserRole.SYS_ADMIN
    //@ts-expect-error TODO: fix this
    ].includes(user === null || user === void 0 ? void 0 : user.role);
  },
  isRp: function isRp(user) {
    return (user === null || user === void 0 ? void 0 : user.role) === UserRole.AGENT;
  },
  isStaff: function isStaff(user) {
    return [UserRole.ADMIN, UserRole.SYS_ADMIN, UserRole.CONTENT_EDITOR, UserRole.STUDENT_ADVISOR, UserRole.STUDENT_MANAGER, UserRole.SALES_PERSON, UserRole.EXTERNAL_CONTRACTOR, UserRole.INTERNATIONAL_RECRUITMENT_OFFICER, UserRole.AGENT_MANAGER, UserRole.AGENT_REGIONAL_MANAGER, UserRole.AGENT_REGIONAL_MANAGER_SUPERVISOR
    //@ts-expect-error TODO: fix this
    ].includes(user === null || user === void 0 ? void 0 : user.role);
  }
};